export default __webpack_public_path__ + "static/media/manali1.f723730d.jpg";